import { useState } from 'react';
import { authApi } from '../api/authApi';

interface UseLoginReturn {
  sendMagicLink: (email: string) => Promise<void>;
  isLoading: boolean;
  isSent: boolean;
  error: string | null;
}

export function useLogin(): UseLoginReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendMagicLink = async (email: string) => {
    setIsLoading(true);
    setError(null);
    try {
      await authApi.sendMagicLink(email);
      setIsSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send magic link');
    } finally {
      setIsLoading(false);
    }
  };

  return { sendMagicLink, isLoading, isSent, error };
}
